import { Controller } from "stimulus"

import Cookies from 'js-cookie';

export default class extends Controller {
  close(e) {
    e.preventDefault();
    Cookies.set('hiringbanner', "closed", { expires: 365 });
    $(this.element).fadeOut(300);
  }
}
